import http from '../../../../http/base';

export default ({ API_PATHS }) => ({
    getFacilityInfo: membersIds => http.get(API_PATHS.facilityInfo, { params: { membersIds } })
});